import type { ReactElement } from "react";
import { Card } from "../../ui/Card/Card";
import { Badge } from "../../ui/Badge/Badge";
import { useMeCrm } from "../../lib/user";
import { DefinitionRow } from "./DefinitionRow";
import styles from "./OrganisationCard.module.css";

export function OrganisationCard(): ReactElement {
  const crm = useMeCrm();
  return (
    <Card>
      <h2 className={styles.title}>Organisation</h2>
      <div className={styles.rows}>
        <DefinitionRow label="Company">{crm?.name ?? "—"}</DefinitionRow>
        <DefinitionRow label="Status">
          {crm ? (
            <Badge tone={crm.status === "active" ? "success" : "neutral"}>
              {crm.status === "active" ? "Active" : "Inactive"}
            </Badge>
          ) : (
            "—"
          )}
        </DefinitionRow>
      </div>
    </Card>
  );
}
